import { render, staticRenderFns } from "./IconSvgLinkedin.vue?vue&type=template&id=0f55a42e&scoped=true&"
import script from "./IconSvgLinkedin.vue?vue&type=script&lang=js&"
export * from "./IconSvgLinkedin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f55a42e",
  null
  
)

export default component.exports